import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Label,
  FormGroup,
  Input,
} from 'reactstrap';
import Select from 'react-select';
import Cleave from 'cleave.js/react';
// import { formatNumberWithCommasAnd2Decimals } from 'utils/maths/InputFormats';
import {
  handleChangeProductType,
  handleChangeUnitTypes,
  handleChangeProductStockType,
  // handleChangeNumberInput,
  // handleOnKeyUpNumberInput,
} from 'pages/Products/ProductManagement/FormHandlers';
import {
  ProductStockTypes,
  UnitTypes,
  InventoryTypes,
} from 'pages/Products/ProductConstants';
import { useSelector } from 'react-redux';
import ProductComposite from 'pages/Products/ProductManagement/ProductComposite';
import { CustomReactSelectStyles } from 'pages/Products/styles/customStyles';
import { useTranslation } from 'react-i18next';
import {
  GetProductByIdFromAPI,
  ProductFormDetailsInterface,
  SelectOptions,
} from 'types/productTypes';
import { RootState } from 'slices';
import { Dispatch } from 'redux';
import { FormikProps } from 'formik';
import styles from 'pages/Products/styles/products.module.css';
import { useEffect, useMemo } from 'react';

const ProductStockInfo = ({
  dispatch,
  formik,
  toggleModal,
  closeModal,
  selectProduct,
  searchInputRef,
}: {
  dispatch: Dispatch;
  formik: FormikProps<ProductFormDetailsInterface>;
  toggleModal: (index?: number | null) => void;
  closeModal: () => void;
  selectProduct: (
    product: GetProductByIdFromAPI,
    formik: FormikProps<ProductFormDetailsInterface>
  ) => void;
  searchInputRef: React.RefObject<HTMLInputElement>;
}) => {
  const { t } = useTranslation();
  const productFormState = useSelector((state: RootState) => state.Product);
  const layoutState = useSelector((state: RootState) => state.Layout);
  const { isNoStock, isPieces, showAllValidateErrors } = productFormState.form;
  const { layoutModeType } = layoutState;
  const isDarkMode = layoutModeType === 'dark';

  // const InventoryOptions = isPieces
  //   ? InventoryTypes(t).flatMap((group: SelectOptions) => group.options)
  //   : InventoryTypes(t).flatMap((group: SelectOptions) =>
  //       group.options.filter((inventory) => inventory.value === '1')
  //     );

  const countSelectedProductOpts = useMemo(() => {
    const count = formik.values.productOptions.reduce(
      (count, item) => count + (!item.selected ? 1 : 0),
      0
    );

    return count;
  }, [formik.values.productOptions]);

  const hasAnySelected = useMemo(() => {
    return formik.values.productOptions.length !== countSelectedProductOpts;
  }, [formik.values.productOptions.length, countSelectedProductOpts]);

  useEffect(() => {
    if (hasAnySelected && formik.values.unit_type !== '0') {
      const evt = {
        target: { name: 'unit_type', value: '0' },
      } as unknown as React.ChangeEvent<HTMLInputElement>;
      formik.handleChange(evt);
      handleChangeUnitTypes(evt, formik, dispatch);
    }
  }, [hasAnySelected, formik.values.unit_type, formik, dispatch]);

  const InventoryOptions =
    hasAnySelected && isPieces
      ? InventoryTypes(t).flatMap((group: SelectOptions) =>
          group.options.filter((inventory) => inventory.value !== '3')
        )
      : isPieces
      ? InventoryTypes(t).flatMap((group: SelectOptions) => group.options)
      : InventoryTypes(t).flatMap((group: SelectOptions) =>
          group.options.filter((inventory) => inventory.value === '1')
        );
  return (
    <Card>
      <CardHeader>
        <h5 className="card-title mb-0">{t('ProductPage_Stock')}</h5>
      </CardHeader>

      <CardBody className={`${styles['card-body-pd']}`}>
        <Row>
          <Col lg={6}>
            <div className="mb-3 row">
              <Label className="col-sm-3 col-form-label">
                {t('ProductField_ProductType')}
              </Label>
              <Col sm={9}>
                <div>
                  <FormGroup key={3}>
                    {ProductStockTypes(t).map(
                      (p: { label: string; value: string }, _index) => (
                        <div
                          key={p.value}
                          className="form-check form-check-inline"
                        >
                          <Input
                            className="form-check-input"
                            type="radio"
                            name="product_stock_type"
                            id={p.label}
                            value={p.value}
                            checked={
                              formik.values.product_stock_type === p.value
                            }
                            onChange={(e) => {
                              formik.handleChange(e);
                              handleChangeProductType(e, formik, dispatch);
                            }}
                          />
                          <Label className="form-check-label" htmlFor={p.label}>
                            {p.label}
                          </Label>
                        </div>
                      )
                    )}
                  </FormGroup>
                </div>
              </Col>
            </div>

            {/* Product Unit */}
            <div
              className={`mb-3 row stock-group ${isNoStock ? 'd-none' : ''}`}
            >
              <Label className="col-sm-3 col-form-label">
                {t('ProductField_UnitType')}
              </Label>
              <Col sm={9}>
                <div>
                  {UnitTypes(t).map(
                    (u: { label: string; value: string }, _index) => (
                      <div
                        key={u.value}
                        className="form-check form-check-inline"
                      >
                        <Input
                          className="form-check-input"
                          type="radio"
                          name="unit_type"
                          id={u.label}
                          value={u.value}
                          checked={formik.values.unit_type === u.value}
                          onChange={(e) => {
                            formik.handleChange(e);
                            handleChangeUnitTypes(e, formik, dispatch);
                          }}
                          disabled={
                            u.value === '0'
                              ? false
                              : formik.values.productOptions.length ===
                                countSelectedProductOpts
                              ? false
                              : true
                          }
                        />
                        <Label className="form-check-label" htmlFor={u.label}>
                          {u.label}
                        </Label>
                      </div>
                    )
                  )}
                </div>
              </Col>
            </div>

            {/* Stock Type */}
            <div
              className={`mb-3 row stock-group ${isNoStock ? 'd-none' : ''}`}
            >
              <Label
                htmlFor="inventory_type"
                className="col-sm-3 col-form-label"
              >
                {t('ProductField_StockType')}
              </Label>
              <Col sm={9}>
                <Select
                  styles={CustomReactSelectStyles(isDarkMode)}
                  id="inventory_type"
                  name="inventory_type"
                  options={InventoryOptions}
                  value={
                    formik.values.inventory_type
                      ? InventoryOptions.find(
                          (option) =>
                            option.value === formik.values.inventory_type
                        )
                      : null
                  }
                  onChange={(option: { label: string; value: string }) => {
                    formik.setFieldValue('inventory_type', option?.value);
                    formik.setFieldTouched('inventory_type', true);
                    const customEvent = {
                      target: {
                        value: option?.value,
                      },
                    } as React.ChangeEvent<HTMLSelectElement>;
                    handleChangeProductStockType(customEvent, dispatch);
                  }}
                  onBlur={() => {
                    formik.setFieldTouched('inventory_type', true);
                  }}
                  placeholder="Select Inventory..."
                  isSearchable={false}
                />
                {(formik.touched.inventory_type &&
                  formik.errors.inventory_type &&
                  typeof formik.errors.inventory_type === 'string') ||
                (formik.isValid === false &&
                  formik.errors.inventory_type &&
                  showAllValidateErrors === true) ? (
                  <div className={`text-danger `}>
                    {formik.errors.inventory_type}
                  </div>
                ) : null}
              </Col>
            </div>

            {/*//todo Composite section */}
            <ProductComposite
              dispatch={dispatch}
              formik={formik}
              toggleModal={toggleModal}
              closeModal={closeModal}
              selectProduct={selectProduct}
              searchInputRef={searchInputRef}
            />

            <div className="mb-3 row">
              <Label
                htmlFor="quantity_notify"
                className="col-sm-3 col-form-label"
              >
                {t('ProductField_ReorderLevel')}
              </Label>
              <Col sm={9}>
                {/* <Input
                  type="text"
                  className="form-control"
                  id="quantity_notify"
                  name="quantity_notify"
                  value={formatNumberWithCommasAnd2Decimals(
                    formik.values.quantity_notify
                  )}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    handleChangeNumberInput(e, formik);
                  }}
                  onKeyUp={(e: React.KeyboardEvent<HTMLInputElement>) => {
                    handleOnKeyUpNumberInput(e, formik);
                  }}
                  onBlur={formik.handleBlur}
                /> */}
                <Cleave
                  className={`form-control`}
                  id="quantity_notify"
                  name="quantity_notify"
                  value={formik.values.quantity_notify}
                  options={{
                    numeral: true,
                    numeralDecimalScale: 2,
                    numeralIntegerScale: 10,
                    numeralThousandsGroupStyle: 'thousand',
                  }}
                  onChange={(e: any) => {
                    formik.setFieldValue(`quantity_notify`, e.target.rawValue);
                  }}
                  onBlur={formik.handleBlur}
                />
              </Col>
            </div>
          </Col>

          <Col lg={6}>{/* //todo Right Side */}</Col>
        </Row>
      </CardBody>
    </Card>
  );
};
export default ProductStockInfo;
